// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Modal, Button } from 'semantic-ui-react';
// local
// actions
import { closeModal } from 'app/redux/actions/patient/disableErrorModal';

class PatientDisableErrorModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            quantity: null,
            name: null,
        };
    }

    componentWillUnmount = () => this.onClose();

    componentWillReceiveProps(nextProps) {
        const { data } = nextProps.disableErrorPatientModal;
        if (data) {
            this.setState({
                quantity: data.quantity,
                name: data.name,
            });
        }
    }

    onClose = () => this.props.dispatch(closeModal());

    render() {
        // props
        const { isOpened } = this.props.disableErrorPatientModal;
        // state
        const { quantity, name } = this.state;
        return (
            <div>
                <Modal size="small" open={isOpened} onClose={this.onClose}>
                    <Modal.Content className="text-center">
                        <div>
                            <p>
                                O paciente <span className="uppercase">{name}</span> possui solicitação de {quantity} cilindros pendentes.
                            </p>
                            <p>É necessário confirmar a entrega dos cilindros para desativar o paciente. </p>
                        </div>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button className="highlight" content="Ok" onClick={this.onClose} />
                    </Modal.Actions>
                </Modal>
            </div>
        );
    }
}

PatientDisableErrorModal.propTypes = {
    dispatch: PropTypes.func,
    disableErrorPatientModal: PropTypes.object,
};

const mapStateToProps = state => ({
    disableErrorPatientModal: state.disableErrorPatientModal,
});
export default connect(mapStateToProps)(PatientDisableErrorModal);
